import { render, staticRenderFns } from "./wxzj.vue?vue&type=template&id=4f769447&scoped=true&"
import script from "./wxzj.vue?vue&type=script&lang=js&"
export * from "./wxzj.vue?vue&type=script&lang=js&"
import style0 from "./wxzj.vue?vue&type=style&index=0&id=4f769447&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f769447",
  null
  
)

export default component.exports